module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_9005.f6dec326.png";